import {LinkProps} from '@chakra-ui/react';
import {RouteNames} from 'modules/navigation';
import React from 'react';
import {GeoIconDefault} from './GeoIconDefault';
import {GeoIconExtend} from './GeoIconExtend';
export interface GeoIconNavProps extends LinkProps {
	link?: RouteNames;
	src?: string;
	label?: string;
	extended?: boolean;
	// active?: boolean;
}

export const GeoIconNav: React.FC<GeoIconNavProps> = ({
	link,
	src,
	label,
	extended
}: GeoIconNavProps) => {
	// const [form, setForm] = React.useState<formIconNav>('default');
	// const [extended, setExtended] = React.useState(true);

	const renderIcons = () =>
		extended ? (
			<GeoIconExtend link={link} src={src} label={label} />
		) : (
			<GeoIconDefault src={src} link={link} label={label} />
		);

	return <>{renderIcons()}</>;
};
